module.exports = __webpack_public_path__ + "static/media/ShawPen.8ab818ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ShawPen.png
// module id = 11
// module chunks = 0